import React from "react";
import { MainContainer } from "../../components";
import { environment } from "../../modules/config";

export const Info = () => (
  <MainContainer backLink="/admin">
    <pre>{JSON.stringify(environment, null, 2)}</pre>
  </MainContainer>
);
